import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

const authority = process.env.VUE_APP_AUTHORITY || 'https://auth.garantepay.net.br'
const clientId = process.env.VUE_APP_OIDC_CLIENT_ID || '96655e9e-a064-427a-860b-935158a999b4'
const scope = process.env.VUE_APP_OIDC_SCOPE || 'openid profile email roles financeiro_api'
const redirectUri = process.env.VUE_APP_OIDC_REDIRECT_URI || `${window.location.origin}/callback`
const postLogoutRedirectUri = process.env.VUE_APP_OIDC_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/`

const userManager = new UserManager({
  authority,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: 'code',
  scope,
  loadUserInfo: false,
  monitorSession: false,
  automaticSilentRenew: false,
  revokeTokensOnSignout: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage })
})

async function getUser () {
  return userManager.getUser()
}

async function isAuthenticated () {
  const user = await getUser()
  return Boolean(user && !user.expired && user.access_token)
}

async function getAccessToken () {
  const user = await getUser()
  return user && !user.expired ? user.access_token : null
}

async function signInRedirect (returnPath) {
  return userManager.signinRedirect({
    state: { returnPath: returnPath && returnPath !== '/' ? returnPath : '/home' }
  })
}

async function completeSignInRedirect () {
  const user = await userManager.signinRedirectCallback()
  return user?.state?.returnPath || '/home'
}

async function signOutRedirect () {
  const user = await getUser()
  try {
    return await userManager.signoutRedirect({
      id_token_hint: user?.id_token,
      post_logout_redirect_uri: postLogoutRedirectUri
    })
  } catch (error) {
    await userManager.removeUser()
    window.location.assign('/')
  }
}

async function clearAuthState () {
  await userManager.removeUser()
  await userManager.clearStaleState()
}

export default {
  getUser,
  isAuthenticated,
  getAccessToken,
  signInRedirect,
  completeSignInRedirect,
  signOutRedirect,
  clearAuthState
}
